import { AppComponent } from 'src/app/app.component';
import { Component, Input, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';

import { has } from 'lodash';

import { TICKETS_PATHS } from '../../../../../../tickets/tickets';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TicketsAssignService } from '../../tickets-assign.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-ticket-global-problem-check-new',
  templateUrl: './ticket-global-problem-check.component.html',
  styleUrls: ['./ticket-global-problem-check.component.scss'],
  standalone: false,
})
export class TicketGlobalProblemCheckComponent implements OnInit {
  public TICKETS_PATHS = TICKETS_PATHS;
  public gpCheckLoading: boolean;
  public gpCheckFirstLoading: boolean;
  public gpCheckError: boolean;
  public gpCheckData: any;

  @Input() ticket;

  constructor(
    private ticketsService: TicketsAssignService,
    @Inject(AppComponent) private appComp: AppComponent
  ) {}

  ngOnInit() {
    this.gpCheckLoading = false;
    this.gpCheckError = false;
  }

  public checkGlobalProblem(): void {
    this.gpCheckLoading = true;
    this.gpCheckFirstLoading = true;
    this.appComp.update();
    this.ticketsService.getGpCheck(this.ticket.hd_house_id).subscribe(
      (response) => {
        this.gpCheckData = has(response, 'data') ? response['data'] : response;
        this.gpCheckLoading = false;
        this.appComp.update();
      },
      (error) => {
        this.gpCheckData = null;
        this.gpCheckError = true;
        this.gpCheckLoading = false;
        this.appComp.update();
      }
    );
  }

  public toggleWithStatusContext(popover: NgbPopover): void {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
    this.appComp.update();
  }
}
